export const entrypoint = "Auth";
